import type {
  Bono,
  ComparisonRow,
  CostRow,
  FaqItem,
  Plan,
  Testimonial,
  Tomo,
} from '../types/content'

export const tomos: Tomo[] = [
  {
    id: 1,
    label: 'Tomo 1',
    title: 'Fundamentos de Hierro',
    description:
      'Biomecánica básica, movilidad articular, activación escapular y preparación de tendones para evitar lesiones desde el primer día.',
  },
  {
    id: 2,
    label: 'Tomo 2',
    title: 'Fuerza Bruta: Base Motora',
    description:
      'Progresiones de empuje y tirón de cero a avanzado. 12 niveles de dominadas. 12 niveles de flexiones. Pierna y core integrados.',
  },
  {
    id: 3,
    label: 'Tomo 3',
    title: 'Dominio de Estáticos',
    description:
      'Front Lever, Back Lever, Planche Tuck y L-Sit. La física de la palanca explicada. Progresiones exactas nivel por nivel.',
  },
  {
    id: 4,
    label: 'Tomo 4',
    title: 'Dinámicos y Explosión',
    description:
      'Muscle-Up, Kip Swing, potencia de tracción y control del centro de masa. El tomo que más atletas buscan y nadie explica bien.',
  },
  {
    id: 5,
    label: 'Tomo 5',
    title: 'Ingeniería Nutricional',
    description:
      'Nutrición adaptada al atleta de calistenia en Argentina. Alimentos locales, requerimientos exactos, fases de volumen y definición sin suplementos caros.',
  },
  {
    id: 6,
    label: 'Tomo 6',
    title: 'Programación Maestra',
    description:
      'Diseño de mesociclos, periodización anual, gestión de fatiga y deloads. El sistema para ser tu propio coach de manera indefinida.',
  },
]

export const tomoIncludes: string[] = [
  'Protocolo listo para ejecutar desde el primer día',
  'Progresiones por nivel con criterios claros de avance',
  'Ejercicios adaptados a plaza pública argentina',
  'Checklist técnico por movimiento',
  'Errores comunes y correcciones específicas',
  'Planillas de registro y seguimiento',
  'Protocolo de prevención de lesiones',
  '100% adaptado al contexto argentino',
]

export const bonos: Bono[] = [
  {
    id: '01',
    title: 'Mapa de Inicio 14 Días',
    description:
      'Ruta exacta de 14 días para medir tu nivel, activar tu cuerpo y empezar sin improvisar.',
    value: '$8.000',
  },
  {
    id: '02',
    title: 'Checklist Técnica de Hierro',
    description:
      '50 correcciones visuales para mejorar dominadas, flexiones, estáticos y Muscle-Up.',
    value: '$10.000',
  },
  {
    id: '03',
    title: 'Tracker de Progreso Cero Límites',
    description:
      '12 semanas de registro de series, holds y marcas para saber si estás progresando.',
    value: '$9.000',
  },
  {
    id: '04',
    title: 'Diccionario de Progresiones',
    description:
      'Qué hacer cuando un ejercicio no sale. Regresiones exactas para cada movimiento.',
    value: '$8.000',
  },
  {
    id: '05',
    title: 'Kit Antilesiones Express',
    description:
      'Rutina de 10 minutos para muñecas, codos y hombros antes de cada sesión.',
    value: '$9.000',
  },
  {
    id: '06',
    title: 'Combos Argentinos de Energía',
    description:
      '21 comidas simples con alimentos argentinos para entrenar fuerte sin gastar de más.',
    value: '$9.000',
  },
]

export const painPoints: string[] = [
  'Semanas buscando rutinas en internet que nunca encajan con tu nivel real',
  'Sin saber si hacer más series, más reps o avanzar de progresión',
  'Siempre los mismos ejercicios porque no tenés un mapa de progresiones serio',
  'El Front Lever, el Muscle-Up, el Pistol Squat — sin un camino claro hacia ellos',
  'Entrenando tren superior todo el tiempo sin pierna, core ni nutrición estructurada',
  'Fin de semana agotado, el lunes volvés a empezar el mismo ciclo sin avance visible',
]

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'MP',
    name: 'Matías P.',
    location: 'Córdoba',
    quote:
      'En 2 semanas logré mi primera dominada limpia. El sistema de progresiones es clarísimo y nunca más me perdí.',
  },
  {
    initials: 'LV',
    name: 'Lucas V.',
    location: 'Rosario',
    quote:
      'El Tomo de estáticos es oro puro. El Front Lever por fin tiene sentido. Las progresiones paso a paso son el diferencial.',
  },
  {
    initials: 'SR',
    name: 'Sebastián R.',
    location: 'Buenos Aires',
    quote:
      'Llevaba meses estancado en el Muscle-Up. Con el Tomo 4 lo logré en 3 semanas. Vale cada peso.',
  },
]

export const testimonials: Testimonial[] = [
  {
    initials: 'CR',
    name: 'Cristian R.',
    location: 'Mendoza',
    tag: 'Megakit + Manual Muscle Up Blueprint',
    quote:
      'El Muscle Up Blueprint me cambió todo. Ya no improviso. Sé exactamente qué hacer cada día y mis dominadas pasaron de 4 a 11 en 8 semanas.',
  },
  {
    initials: 'FM',
    name: 'Franco M.',
    location: 'Buenos Aires',
    tag: 'Atleta de Calistenia',
    quote:
      'Con el Tomo 4 logré mi primer Muscle-Up limpio. El sistema de negativos y el False Grip explicados así no los había visto en ningún lado.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    tag: 'Atleta de Calistenia',
    quote:
      'Empecé de cero y al mes ya tenía mi primera dominada. El Tomo 1 me salvó las muñecas desde el primer día.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    tag: 'Atleta de Calistenia',
    quote:
      'El Tracker de Progreso me hizo ver que estaba sobreentrenando Pull y sin suficiente Push. Ajusté y el estancamiento desapareció.',
  },
]

export const plans: Plan[] = [
  {
    id: 'megakit',
    name: 'MEGAKIT CALISTENIA CERO LÍMITES',
    includes: '6 Tomos + 6 Bonos',
    idealFor: 'Principiante → Élite. Todos los niveles.',
    oldPrice: '$51.000',
    price: '$19.990 ARS',
    cta: 'QUIERO MI MEGAKIT AHORA',
    checkoutUrl: 'https://www.nucleofit.shop/cart/52619076010266:1',
  },
  {
    id: 'megakit-pro',
    name: 'MEGAKIT + MANUAL MUSCLE UP BLUEPRINT',
    featured: true,
    includes: '6 Tomos + 6 Bonos + Manual Muscle Up Blueprint',
    idealFor:
      'Atletas que van por su primer Muscle-Up o quieren perfeccionarlo',
    oldPrice: '$69.000',
    price: '$27.990 ARS',
    cta: 'QUIERO EL MEGAKIT + MANUAL',
    checkoutUrl: 'https://www.nucleofit.shop/cart/52619078140186:1',
  },
  {
    id: 'megakit-full',
    name: 'MEGAKIT + MANUAL MUSCLE UP BLUEPRINT + MANUAL VERTICALIDAD ABSOLUTA',
    includes:
      '6 Tomos + 6 Bonos + Manual Muscle Up Blueprint + Manual Verticalidad Absoluta',
    idealFor:
      'Atletas que quieren el sistema completo: tracción, Muscle-Up y verticales',
    oldPrice: '$89.000',
    price: '$33.900 ARS',
    cta: 'QUIERO EL PACK COMPLETO',
    checkoutUrl: 'https://www.nucleofit.shop/cart/52791022256410:1',
  },
]

export const moduleComparison: ComparisonRow[] = [
  {
    situation: 'No sé qué progresión usar para llegar al Muscle-Up',
    without: 'Adivinás y perdés semanas',
    with: 'Ruta exacta según tu test inicial de tracción',
  },
  {
    situation: 'Quiero potencia de tirón y transición al mismo tiempo',
    without: 'Improvisás la semana',
    with: 'Bloques de fuerza y explosividad ordenados',
  },
  {
    situation: 'Me estanqué en el mismo ejercicio 3 semanas',
    without: 'No sabés qué cambiar',
    with: 'Diagnóstico y ajuste de variable específica',
  },
  {
    situation: 'Se me traba la transición sobre la barra',
    without: 'Repetís el error una y otra vez',
    with: 'Corrección técnica paso a paso con False Grip',
  },
  {
    situation: 'Quiero entrenar 3 días, no 5',
    without: 'El programa no se adapta',
    with: 'Estructura adaptada a tu disponibilidad',
  },
  {
    situation: 'Tengo molestias en codos o muñecas',
    without: 'Parás o te rompés',
    with: 'Variante segura para cada situación',
  },
]

export const moduleIncludes: string[] = [
  'Plan de 8-12 semanas para conquistar tu Muscle-Up',
  'Progresiones de negativos, kip y transición nivel por nivel',
  'Técnica de False Grip explicada paso a paso',
  'Criterios claros de avance en cada progresión',
  'Protocolo de ajuste si algo no progresa',
  'Variantes para 3 o 4 días de entrenamiento',
  'Compatibilidad con la nutrición del Tomo 5',
]

export const costRows: CostRow[] = [
  {
    without: '3 horas buscando rutinas × 40 semanas',
    cost: '120 horas de tu vida por año',
  },
  { without: 'Sin progresiones claras', cost: 'Meses en el mismo nivel' },
  {
    without: 'Sin sistema de deload',
    cost: 'Lesiones por sobreentrenamiento acumulado',
  },
  {
    without: 'Sin nutrición estructurada',
    cost: 'Entrenás fuerte pero no recuperás',
  },
  {
    without: 'Sin tracker ni criterios de avance',
    cost: 'No sabés si estás progresando o perdiendo el tiempo',
  },
  { without: 'Domingo buscando en YouTube', cost: 'El mismo ciclo, el próximo año' },
]

export const faqs: FaqItem[] = [
  {
    question: '¿Sirve para todos los niveles?',
    answer:
      'Sí. El Megakit empieza desde cero absoluto (sin ninguna dominada) y llega hasta movimientos de élite como Muscle-Up, Front Lever y Back Lever. Cada tomo tiene un test inicial para que sepas exactamente desde qué nivel arrancar.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      '100% digital. Una vez confirmado el pago, recibís acceso inmediato a los 6 tomos y 6 bonos en PDF. Podés descargarlos, imprimirlos o usarlos desde tu celular, tablet o computadora.',
  },
  {
    question: '¿Qué lo diferencia del material online gratuito?',
    answer:
      'El material gratuito da ejercicios. El Megakit da un sistema. La diferencia es que con el Megakit sabés exactamente en qué nivel estás, qué progresión usar, cuándo avanzar y cómo medir si estás progresando. No es información suelta: es ingeniería corporal.',
  },
  {
    question: '¿Necesito equipamiento especial?',
    answer:
      'No. Todo el sistema está diseñado para plazas públicas argentinas. Una barra, el suelo y tu cuerpo son suficientes para llegar al Muscle-Up y los estáticos.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días de garantía total sin preguntas. Si en 7 días no estás satisfecho, te devolvemos el 100% del dinero. Podés escribirnos a soporte.nucleofit@gmail.com y el reembolso se procesa sin formularios ni demoras.',
  },
]
